import { render } from "./ButtonNav.vue?vue&type=template&id=0c985dde&scoped=true"
import script from "./ButtonNav.vue?vue&type=script&lang=js"
export * from "./ButtonNav.vue?vue&type=script&lang=js"

import "./ButtonNav.vue?vue&type=style&index=0&id=0c985dde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c985dde"]])

export default __exports__